import React from "react";
import PropTypes from "prop-types";

import { Item } from "../GridComponents";

const SingleItem = props => {
	const { item, fieldsToDisplay } = props;
	const { id, name, text } = item;
	let title = "";
	if (fieldsToDisplay && fieldsToDisplay.length > 0) {
		fieldsToDisplay.forEach(field => (title += item[field] + " "));
	} else if (name) {
		title = name;
	} else if (text) {
		title = text;
	} else {
		title = id;
	}

	const CRUD = {
		deleteItem: () => props.deleteItem(id, title),
		duplicateItem: props.duplicateItem,
		editItem: props.editItem,
	};

	return <Item id={id} title={title} crud={CRUD} />;
};

SingleItem.propTypes = {
	fieldsToDisplay: PropTypes.array,
	item: PropTypes.object,
	deleteItem: PropTypes.func,
	duplicateItem: PropTypes.func,
	editItem: PropTypes.func,
};

export default SingleItem;
